module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Du har blivit nämd i en anteckning på kandidaten":"You have been mentioned in a comment on the candidate"},"sv":{"Du har blivit nämd i en anteckning på kandidaten":"Du har blivit nämd i en anteckning på kandidaten"}}')
  delete Component.options._Ctor
}
